import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { InputTextModule } from "primeng/inputtext";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SkeletonModule } from "primeng/skeleton";

import { Observable } from "rxjs";

import { AccordionComponent, ButtonComponent } from "@shared/components";
import { GlobalService } from "@shared/services";
import { LocalStorage } from "@shared/enums";
import {
  MemberInfoResponse,
  RequestState,
  SentinelProfileResponse,
} from "@shared/models";
import { LowerCasePipe } from "@shared/pipes";
import { RecentEmulates } from "@home/models/recent-emulates";
import { AdminService } from "@home/services/admin.service";
import { ButtonModule } from "primeng/button";
@Component({
  selector: "app-admin",
  standalone: true,
  imports: [
    AccordionComponent,
    InputTextModule,
    ButtonComponent,
    FormsModule,
    ProgressSpinnerModule,
    CommonModule,
    SkeletonModule,
    LowerCasePipe,
    ButtonModule,
  ],
  templateUrl: "./admin.component.html",
  styleUrl: "./admin.component.scss",
})
export class AdminComponent implements OnInit {
  globalService = inject(GlobalService);
  adminService = inject(AdminService);

  emulatedUser: string | null = null;
  contactShown: boolean = false;

  emulatedUserProfile$: Observable<RequestState<SentinelProfileResponse>> =
    {} as Observable<RequestState<SentinelProfileResponse>>;
  memberInfo$: Observable<RequestState<MemberInfoResponse>> = {} as Observable<
    RequestState<MemberInfoResponse>
  >;

  statusDetails: { key: string; label: string }[] =
    this.adminService.getStatusDetails();
  companyDetails: { key: string; label: string }[] =
    this.adminService.getCompanyDetails();
  recentEmulates: RecentEmulates[] = this.adminService.getRecentEmulates();

  ngOnInit(): void {
    const emulatedUser = localStorage.getItem(LocalStorage.EmulatedUser);
    if (emulatedUser) {
      this.emulatedUser = emulatedUser;
      this.emulatedUserProfile$ =
        this.adminService.initEmulatedUserProfile(emulatedUser);
    }
  }

  getValue(key: string, profile: SentinelProfileResponse): string | number {
    return profile[key as keyof SentinelProfileResponse] || "N/A";
  }

  getContentHeight(): string {
    const emulatingOffset = this.emulatedUser ? 34 : 0;
    const otherContent =
      this.globalService.navbarHeight() + emulatingOffset + 385;
    return `calc(100vh - ${otherContent}px)`;
  }

  handleReEmulate(employee: string): void {
    this.emulatedUser = employee;
    this.handleEmulate();
    this.recentEmulates = this.adminService.getRecentEmulates();
  }

  handleEmulate(): void {
    if (this.emulatedUser) {
      this.emulatedUserProfile$ = this.adminService.emulateUser(
        this.emulatedUser,
      );
    }
  }

  handleStopEmulate(): void {
    this.emulatedUser = "";
    this.contactShown = false;
    this.adminService.stopEmulation();
    this.recentEmulates = this.adminService.getRecentEmulates();
  }

  getMemberInfo(): void {
    this.contactShown = true;
    this.memberInfo$ = this.adminService.getMemberInfo();
  }
}
